import {
  useAudioPlayerRef,
  useAudioPlayerState,
  useBootstrapAudioPlayer,
  useToggleAudioPlaying,
  AudioPlayerContainer,
} from '@trinity/chat-components/containers/AudioPlayer';
import { cx } from '@trinity/chat-components/utils';
import Button from './Button';
import styles from './style/Player.module.css';

type Props = {
  className?: string;
  audio: React.DetailedHTMLProps<React.AudioHTMLAttributes<HTMLAudioElement>, HTMLAudioElement>;
};

export const MiniAudioPlayer = (props: Props) => {
  return (
    <AudioPlayerContainer>
      <MiniAudioPlayerContent {...props} />
    </AudioPlayerContainer>
  );
};

const MiniAudioPlayerContent = ({
  audio,
  className,
}: Props) => {

  const [, setPlayerRef] = useAudioPlayerRef();
  const [{ playing }] = useAudioPlayerState();

  const togglePlaying = useToggleAudioPlaying();
  const bootstrapAudioPlayer = useBootstrapAudioPlayer();

  return (
    <>
      <div className={cx(styles.root, className)}>
        <Button
          playing={playing}
          togglePlaying={togglePlaying} />
      </div>
      <audio
        ref={setPlayerRef}
        {...bootstrapAudioPlayer()}
        {...audio} />
    </>
  );
};